import { constants, coreActions, coreStore, dataServices, services } from '@ambita/ambita-components-core';
import * as userConstants from "../constants/User";
var util = services.util;
var coreConstants = constants.core;
var userApi = {
    login: function (username, password) {
        coreActions.login(username, password);
    },
    loginWithAccessToken: function (accessToken) {
        coreActions.loginWithAccessToken(accessToken);
    },
    loginAnonymous: function () {
        coreActions.login(userConstants.ANONYMOUS_USER, userConstants.ANONYMOUS_PASSWORD, dataServices.config.RESTRICTED_CLIENT_ID_INFOLAND);
    },
    isAuthorized: function () {
        return coreStore.isAuthenticated();
    },
    getCurrentUser: function () {
        return util.clone(coreStore.getUser());
    },
    logout: function () {
        coreActions.logout();
    },
    on: function (event, callback) {
        if (event in coreConstants) {
            coreStore.on(coreConstants[event], callback);
        }
        else {
            throw Error("Event " + event + " is not available");
        }
    },
    once: function (event, callback) {
        if (event in coreConstants) {
            coreStore.once(coreConstants[event], callback);
        }
        else {
            throw Error("Event " + event + " is not available");
        }
    },
    off: function (event, callback) {
        if (event in coreConstants) {
            coreStore.off(coreConstants[event], callback);
        }
        else {
            throw Error("Event " + event + " is not available");
        }
    }
};
export default userApi;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ambita/ambita-components-infoland-internal/dist/components/api/UserApi.js
// module id = 2
// module chunks = 2